export default __webpack_public_path__ + "fonts/cp_desc.d2d38ce6651b34c30e14cc06e4da57a3.png";